import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import moment from 'moment'

// @ts-ignore
import s from './form.css';
import Collapse, { Panel } from '../../../components/Collapse/Collapse';
import { getDataFromServerInterface } from '../../../controller';


class HotTopicPane extends Component {
  dataRef = null
  state = {
    url: 'http://back.dbrank.net:8889/saas/topic/get_hot_topics?brand_name=%E5%A4%AA%E5%8F%A4%E9%9B%86%E5%9B%A2&start_time=2020-10-01&end_time=2020-12-31',
    colorEditIndex: null,
    itemId: null,
    itemColor: '',
    itemName: '',
    name: '',
    errorStatus: {
      state: false,
      msg: ''
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.list !== this.props.list ) {
      const dataDom = this.dataRef
      dataDom.value = this.getTextArea(nextProps.list)
    }
  }

  handleChange = (type, e) => {
    const val = typeof e === 'string' ? e : e.target.value 
    this.setState({
      [type]: val
    })
  }

  clear = () => {
    const { onChange } = this.props;
    onChange({}, []);
  }

  setError = (state, msg) => {
    this.setState({
      errorStatus: {
        state, msg
      }
    })
  }

  textareaChange = (e) => {
    const {onChange} = this.props
    const {value} = e.target

    this.setError(false, '')

    const list = value.split('\n').filter(item => !!item).map((item, index) => {
      const itemArr = item.trim().split(/\s/)
      const [name, begin, end, ...list] = itemArr
      const beginMoment = moment(begin)
      const endMoment = moment(end)

      if (!beginMoment.isValid() || !endMoment.isValid()) {
        this.setError(true, '开始时间和结束时间确保是时间格式，检查是否标题中有空格')
      }

      const diff = beginMoment.diff(endMoment,"day")
      const date = Array(Math.abs(diff || 0) + 1).fill(1).map((item, index) => {
        return diff < 0 ? beginMoment.clone().add(index, 'days').format('YYYY-MM-DD') : beginMoment.clone().add(index + 1, 'days').format('YYYY-MM-DD')
      })

      return {
        name,
        begin,
        end,
        date: date,
        list: list.map((ele, _index) => {
          const num = parseInt(ele||0)
          if (isNaN(num)) {
            this.setError(true, '对应数值请使用数字格式')
          }
          return {
            name,
            value: [
              index,
              date[_index],
              date[_index + 1],
              num
            ]
          }
        })
      }
    })


    list.forEach(item => {
      if (item.date.length - item.list.length < 1) {
        this.setError(true, '请确保时间间隔大于数据长度')
      }
    });

    onChange({}, list);
  }

  /**
   * 将数组转文本
   * @memberof IndustryContent
   */
  getTextArea = (list) => {
    if(list[0] && list[0].begin) {
      return list.map(item => 
        `${item.name}\t${item.begin}\t${item.end}\t${item.list.map(item => item.value[3]).join('\t')}`
      ).join('\n')
    }
    return ''
  }

  getData = (src) => {
    const {onChange} = this.props
    getDataFromServerInterface({
      url: src
    })
    .then(res => {
      onChange({}, {interfaceData: res})
    })
  }

  toggleSource = (e) => {
    const { onChange } = this.props;
    const val = e.target.value
    onChange({}, {dataSource: val})
  }
  toggleDateInterval = (e) => {
    const { onChange } = this.props;
    const val = e.target.value
    onChange({}, {dateInterval: val})
  }

  setRef = (ref) => {
    this.dataRef = ref
  }

  render () {
    const {errorStatus, url} = this.state
    const {dataSource, interfaceData, dateInterval} = this.props
    return (
      <Collapse className={s.collapse}>
        <Panel header="数据" expand>
          数据源：
          <select value={dataSource} onChange={this.toggleSource}>
            <option value="input">输入</option>
            <option value="interface">接口</option>
          </select>

          {/* 避免新生成数据没有dom */}
          <div style={{display: dataSource === 'input' ? 'block' : 'none'}}>
            <p style={{color: 'green'}}>* /s代表一个空格，/n代表换行</p>
            <p style={{color: 'green'}}>数据格式：标题	开始时间	结束时间  数字....(有多少就直接一直往后添加)</p>
            <textarea style={{
              borderColor: errorStatus.state ? '#f00' : '#000'
            }} ref={this.setRef} onBlur={this.textareaChange} cols={70} rows={8} />
            {errorStatus.state && <p style={{color: '#f00'}}>{errorStatus.msg}</p>}
          </div>
          
          <div style={{display: dataSource !== 'input' ? 'block' : 'none'}}>
            url: <input value={url} onChange={e => this.setState({url: e.target.value})} />
            <button onClick={() => this.getData(url)}>获取数据</button>
            <code>
              <pre style={{
                overflow: 'auto',
                maxHeight: 300,
                boxShadow: '0 0 5px #333'
              }}>{JSON.stringify(interfaceData, null, 2)}</pre>
            </code>
          </div>
          
          <div>
            时间间隔：
            <select value={dateInterval} onChange={this.toggleDateInterval}>
              <option value="day">默认</option>
              <option value="week">星期</option>
              <option value="month">月</option>
            </select>
          </div>
        </Panel>
      </Collapse>
    )
  }
};



export default withStyles(s)(HotTopicPane)


// WEBPACK FOOTER //
// src/routes/customChart/components/HotTopic.js